import { useEffect, useState } from "react";
import { getSystem } from "../services/userService";

interface IuseFetchSystem {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const useFetchSystem = ({ setIsLoading }: IuseFetchSystem) => {
  const [systemData, setSystemData] = useState<any[]>([]);

  useEffect(() => {
    setIsLoading(true);
    const getSystemData = async () => {
      try {
        const res = await getSystem();
        setSystemData(res);
      } catch (err) {
        setSystemData([]);
      } finally {
        setIsLoading(false);
      }
    };
    getSystemData();
  }, []); // ✅ Removed setIsLoading to prevent infinite loops

  return [systemData];
};

export default useFetchSystem;
